/*
 * @Author: masonzhou
 * @Date: 2024-01-19 09:15:58
 * @LastEditTime: 2024-02-27 09:15:54
 * @FilePath: \yl-cjsph-tms-operation-front\src\utils\request\config.ts
 * @Description:
 */
/*
 * @Description:
 * @Author: muqingkun
 * @Date: 2023-11-16 09:49:57
 * @LastEditTime: 2023-11-16 14:30:35
 * @LastEditors: Please set LastEditors
 * @Reference:
 */
const { VITE_APP_API_URL, VITE_CUSTOME_ENV, VITE_GLOBALPY_API_URL } =
  import.meta.env;
console.log(
  `%c 当前环境 %c【${VITE_CUSTOME_ENV}】 `,
  'background: #35495e; padding: 4px; border-radius: 3px 0 0 3px; color: #fff',
  'background: #e6262c; padding: 4px; border-radius: 0 3px 3px 0; color: #fff'
);
export const upload_url = '/excel/uploadFile'; // 文件上传 时效文件
export const upload_perpetualUrl = '/data/uploadFile'; // 文件上传 永久可访问文件

export const BASE_URL: string =
  VITE_CUSTOME_ENV === 'dev' ? '/api' : VITE_APP_API_URL;

export const CJS_GLOBALPY_URL: string = VITE_GLOBALPY_API_URL;
export const I18N_URL: string = VITE_GLOBALPY_API_URL;
// VITE_CUSTOME_ENV === 'dev' ? '/api1' : VITE_GLOBALPY_API_URL;

export const UPLOAD_URL = BASE_URL + upload_url; // 文件上传 时效文件

export const UPLOAD_PERURL = BASE_URL + upload_perpetualUrl; // 文件上传 永久可访问文件


// 后端接口返回的状态码常量
export const RESPONSE_CODE = {
  SUCCESS: 1, // 成功
  SUCCESS_COPY: 1, // 成功 临时使用
  EXPIRED: '000002' // token过期
};
